export default "__VITE_ASSET__zgy_65fn__"